/* eslint-disable no-unused-vars */
import { IconButton, ParagraphWithTooltip, LocationSelectedItemName } from 'components';
import { DeleteIcon } from 'assets/icons';
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const SelectedItem = ({ env, itemData, handleDeleteItem }) => {
  return (
    <ItemContainer>
      <NameWrap>
        <ParagraphWithTooltip text={<LocationSelectedItemName itemData={itemData} env={env} />} />
      </NameWrap>

      <IconButton.SmallSize
        style={{ marginLeft: 'auto', minWidth: '32px' }}
        isDefaultMuted
        icon={DeleteIcon}
        type={IconButton.btnTypes.tertiary}
        onClick={() => handleDeleteItem(itemData)}
      />
    </ItemContainer>
  );
};

const NameWrap = styled.div`
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  max-width: calc(100% - 34px);
`;

const ItemContainer = styled.div`
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  background: #fff;
  height: 32px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 2px;
  justify-content: space-around;
  align-items: center;
  padding-left: 8px;
  margin-top: 2px;
  width: fit-content;
  max-width: 100%;
`;
